import { render, staticRenderFns } from "./PendingDependentsSpouseList.vue?vue&type=template&id=67d7a1c4&"
import script from "./PendingDependentsSpouseList.vue?vue&type=script&lang=js&"
export * from "./PendingDependentsSpouseList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pending-details.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports